<template>
  <el-dialog
    :title="title"
    :visible.sync="open"
    append-to-body
    :fullscreen="true"
    :before-close="cancelOpen"
    :show-close="false"
  >
    <!-- <div style="height:99vh;width:100vw;"> -->
    <div style="height: 85vh;width: 100%;position: relative;">
      <!-- <el-button style="position: absolute;right: 20px;top: -60px;font-size:20px ;" type="danger" icon="el-icon-close"
        @click="cancelOpen" circle></el-button> -->
      <!-- <el-button style="position: absolute;right: 20px;top: -60px;font-size:20px ;" type="danger" icon="el-icon-close"
          @click="cancelOpen" circle></el-button> -->
      <i
        class="el-icon-close"
        style="position: absolute;right: 20px;top: -60px;font-size:36px;cursor: pointer;"
        @click="cancelOpen"
      ></i>
      <iframe
        style="height: 100%;width:100%;"
        :src="src"
        frameborder="0"
      ></iframe>
      <div
        v-if="scale < 2"
        style="width: 100%;height: 80%;position: absolute;top: 0;left: 0;z-index:999;"
      ></div>
    </div>
    <!-- </div> -->
  </el-dialog>
</template>

<script>
import LuckyExcel from "luckyexcel";
import axios from "axios";
//引入相关样式
import Cookies from "js-cookie";

export default {
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "view",
    },
    form: {
      type: Object,
    },
  },
  data() {
    return {
      scale: scale,
      formurl: "",
      excelView: "",
      // title: "view",
      formId: "",
      src: "",
    };
  },

  created() {
    // http://192.168.1.7:8001/#/iframePage?id=1726261374900858882
    console.log(window.location);
    // this.src = 'http://59.110.159.111/gpweb' + '/#/iframePage?id=' + this.$route.query.id
    // this.src = window.location.origin + '/#/iframePage?id=' + this.$route.query.id

    // this.src = 'http://59.110.159.111/gpweb' + '/#/iframePage?id=' + this.form.id
    console.log("window.location.origin", window.location.origin);
    this.src = window.location.origin + "/#/iframePage?id=" + this.form.id;

    // console.log("deptList", this.$route.query);
    // this.formId = this.$route.query.id;
    // this.getOriginFile(); // 获取远端文件
  },
  methods: {
    cancelOpen() {
      this.$emit("cancelOpen");
      // this.$router.go(-1);
    },
    // 获取传递的url参数
    getComment() {
      var afterUrl = window.location.search;
      let str = afterUrl.split("?")[1].split("&");
      for (let i = 0; i < str.length; i++) {
        let a = str[i].split("=");
        this.obj[a[0]] = a[1];
      }
    },
    getOriginFile() {
      axios({
        url:
          window.SITE_CONFIG["apiUpURL"] +
          "/sys/sysstock/getAccessUrl?id=" +
          this.formId,
        responseType: "blob",
        headers: {
          token: Cookies.get("token") || "",
        },
      })
        .then((res) => {
          if (res.data) {
            // var data = 'http://59.110.159.111/gpweb/HK.xlsx'
            const blob = new Blob([res.data]);
            const file = new File([blob], "fileName");
            this.init(file); // 开始渲染
          } else {
            this.$message({
              message: res.msg,
              type: "error",
              duration: 2000,
            });
            this.cancel();
          }
        })
        .catch((e) => {
          this.errorTitle = "文件解析失败，请下载后使用 Excel 打开或点击重试！";
          this.errStatus = 2;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 渲染方法，接受文件对象，如果是本地文件直接传入文件即可
    init(file) {
      luckysheet.destroy(); // 先销毁当前容器
      LuckyExcel.transformExcelToLucky(file, (exportJson) => {
        if (exportJson.sheets === null || !exportJson.sheets.length) {
          this.$message.error("无法读取excel文件的内容,当前不支持xls文件!");
          return;
        }
        console.log("exportJson.sheets", exportJson);
        exportJson.sheets[0].zoomRatio = 1;
        luckysheet.create({
          container: "luckysheet",
          showinfobar: false,
          showtoolbar: false,
          lang: "zh",
          data: exportJson.sheets,
          title: exportJson.info.name,
          userInfo: exportJson.info.name.creator,
          devicePixelRatio: 80
        });
        var numberList = luckysheet.getLuckysheetfile();
        for (let index = 0; index < numberList.length; index++) {
          const element = numberList[index];
          for (let i = 0; i < element.data.length; i++) {
            const elementI = element.data[i];
            for (let j = 0; j < elementI.length; j++) {
              const elementJ = elementI[j];
              if (elementJ && typeof elementJ.v == "number" && i > 23) {
                elementJ.ht = 2;
              }
            }
          }
        }
      });
    },
  },
};
</script>
<style>
#luckysheet {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 800px;
}
</style>
